import React, { useEffect, useRef, useState } from "react";
import { askAviationQuestion } from "../actions/dashboardAction";
import LoadingBar from "react-top-loading-bar";
import { Modal } from "react-bootstrap";
const crosshair =
  "https://s3.amazonaws.com/media-dev.salvex.com/static/images/crosshair.svg";

const Help = (props) => {
  const ref = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [page, setPage] = useState("1");
  const [data, setData] = useState({});
  const [user, setUser] = useState("");
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  const member =
    typeof window !== "undefined" && JSON.parse(localStorage.getItem("member"));

  useEffect(() => {
    if (typeof window !== "undefined" && localStorage.getItem("token")) {
      const member = JSON.parse(localStorage.getItem("member"));
      const value = { ...data };
      value.name = member.name01;
      value.email = member.email;
      value.phone =
        member.phone && member.phone != "undefined" ? member.phone : "";
      setData(value);
      setUser(member.name01);
    }
  }, [showForm]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const isFormClosed = localStorage.getItem("isFormClosed");
      const formClosedAt = localStorage.getItem("formClosedAt");
      if (
        (!isFormClosed &&
          (!formClosedAt || Date.now() - formClosedAt > 172800000)) ||
        (isFormClosed &&
          (!formClosedAt || Date.now() - formClosedAt > 172800000))
      ) {
        //
        localStorage.setItem("isFormClosed", false);
        toggleForm();
      }
    }
  }, []);

  useEffect(() => {
    if (showForm) {
      const value = { ...data };
      if (props?.auction_id) {
        value.auction_id = props.auction_id;
      }
      if (props?.auction_title) {
        value.auction_title = props.auction_title;
      }
      setData(value);
    }
  }, [showForm]);

  const toggleForm = () => {
    if (showForm) {
      setPage("1");
    }
    setShowForm(!showForm);
  };

  const handleSend = () => {
    const value = { ...data };
    const error = { ...error };
    if (data.name && data.email && data.phone && data.message) {
      setError({});
      setLoading(true);
      ref && ref.current && ref.current.continuousStart();
      const payload = {
        auction_id: value.auction_id,
        message: value.message,
        phone: value.phone,
        name: value.name,
        email: value.email,
        auction_title: value.auction_title,
      };
      askAviationQuestion(payload, (res) => {
        if (res.status === 200) {
          const a = {
            name: "",
            phone: "",
            email: "",
            message: "",
            auction_id: "",
            auction_title: "",
          };
          setData(a);
          setPage("2");
          ref && ref.current && ref.current.complete();
          setLoading(false);
        } else {
          ref && ref.current && ref.current.complete();
          setLoading(false);
        }
      });
    } else {
      error.details = "All fields are required";
      setError(error);
    }
  };

  return (
    <>
      <LoadingBar height={5} color="#47AD1D" ref={ref} />

      <Modal
        show={props.show}
        onHide={() => props.onHide()}
        className="modal fade salvex-modal modal-md hide-header"
        dialogClassName="modal-dialog modal-dialog-centered"
        contentClassName={"help-box-success-content"}
      >
        <Modal.Body className="modal-body">
          {page == "1" && (
            <>
              <h4 class="width-90">We will help you find what you want</h4>
              <div
                class="close-btn"
                data-bs-dismiss="modal"
                onClick={() => props.onHide()}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </>
          )}
          {page == "1" && (
            <>
              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">Name</label>
                    <input
                      type="text"
                      name="Name"
                      placeholder="Name"
                      class="form-control"
                      value={data.name}
                      onChange={(e) => {
                        const value = { ...data };
                        value.name = e.target.value;
                        setData(value);
                      }}
                    />
                  </div>
                  <div class="col-6">
                    <label class="form-label">Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone"
                      value={data.phone}
                      onChange={(e) => {
                        const value = { ...data };
                        value.phone = e.target.value;
                        setData(value);
                      }}
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-12">
                    <label class="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      class="form-control"
                      value={data.email}
                      onChange={(e) => {
                        const value = { ...data };
                        value.email = e.target.value;
                        setData(value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div class="form-group mb-0">
                <div class="form-group" style={{ marginBottom: "0px" }}>
                  <label class="form-label">Question</label>
                  <textarea
                    class="form-control"
                    placeholder="What parts are you looking for? Please give us a description or part number and we will get back to you right away."
                    id="txtMessage"
                    style={{ lineHeight: "1.5" }}
                    value={data.message}
                    onChange={(e) => {
                      const value = { ...data };
                      value.message = e.target.value;
                      setData(value);
                    }}
                  ></textarea>
                </div>
                {error && error.details ? (
                  <p className="error " style={{ margin: "0px" }}>
                    {error.details}
                  </p>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
          {page == "2" && (
            <>
              <div class="sucessfull-submit-box help-box-success">
                <img src={crosshair} alt="crosshair" />
                <h4 style={{ fontSize: "1.25rem" }}>
                  Thank you for your enquiry. We will get back to you right
                  away.
                </h4>
                <button
                  type="button"
                  class={`btn btn-default btn-sm ${loading && "disabled"}`}
                  onClick={() => {
                    setPage("1");
                    props.onHide();
                  }}
                >
                  Close
                </button>
              </div>
            </>
          )}
        </Modal.Body>
        <div class="modal-footer">
          {page == "1" && (
            <button
              type="button"
              class={`btn btn-default btn-sm ${loading && "disabled"}`}
              onClick={() => handleSend()}
            >
              Send
            </button>
          )}
        </div>
      </Modal>
    </>
  );
};

export default React.memo(Help);
